<template>
    <div>
        <v-btn :color=color
               class="text-none"
               rounded
               depressed
               :loading=buttonLoading
               @click="onButtonClick">
            <v-icon left>
                mdi-cloud-upload
            </v-icon>
            {{ buttonText }}
        </v-btn>
        <input ref="uploader"
               class="d-none"
               type="file"
               :accept="acceptAttribute"
               :key="fileInputKey"
               @change="onFileChanged">
        <br>
    </div>
</template>

<script>
    import {
        mdiClose,
        mdiDelete,
    } from '@mdi/js'
    export default {
        props: {
            defaultButtonText: { default: "Sélectionner un fichier" },
            selectedFileName: { default: '' },
            color: { default: "primary" },
            loading: { default: false },
            ignoredFiles: { default: null },
            acceptFormats: { default: () => ["pdf", "png", "jpg", "jpeg"] },
        },

        data() {
            return {
                // Icon importés depuis mdi/js pour les icones d'édition/suppression
                icons: {
                    mdiClose,
                    mdiDelete,
                },
                // selectedFile: null,
                isSelecting: false,
                fileInputKey:0,
            }
        },

        computed: {
            acceptedFiles() {
                return this.acceptFormats;
            },

            acceptAttribute() {
                return this.acceptedFiles.map(ext => '.' + ext).join(',');
            },

            buttonText() {
                return this.selectedFileName ? this.selectedFileName : this.defaultButtonText
            },

            buttonLoading() {
                return this.loading || this.isSelecting
            }
        },

        methods: {
            // Quand le bouton est cliqué
            onButtonClick() {
                this.isSelecting = true
                window.addEventListener('focus', () => {
                    this.isSelecting = false
                }, { once: true })

                this.$refs.uploader.click()
            },

            resetClick(){
                this.fileInputKey++;
            },

            // Renvoyer le fichier sélectionné vers le parant
            onFileChanged(e) {
                // Vérifier la taille du fichier
                if(e.target.files[0] != null && (e.target.files[0].size/1024)> 8000){
                    return;
                }

                // Vérifier l'extension du fichier
                if ((e.target.files[0] != null &&  this.acceptedFiles.indexOf(e.target.files[0].name.split('.').pop().toLowerCase())>-1) 
                    || this.acceptedFiles == null
                    ) {
                        this.$emit('file-update', e.target.files[0])
                }else {
                    alert(this.$storeUm6p.Label.Annexes.FormatNonSupporte)
                }
            },
        }
    }
</script>

<style scoped>
    .v-icon--left {
        margin-right: 8px;
    }
    .v-btn {
        color: white
    }
</style>